import { ERROR_CODE } from '@config/errors';

import { CustomValidatorOptions, CustomValidatorResult } from './types';

export const customValidator = <V>(
  value: null | undefined | V[],
  options: CustomValidatorOptions
  // eslint-disable-next-line consistent-return
): CustomValidatorResult => {
  if (!options.predicate(value)) {
    return options.message ?? ERROR_CODE.FIELD_IS_INVALID;
  }
};
